import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M344 392c0 13.3-10.7 24-24 24s-24-10.7-24-24V145.9l-63 63c-9.4 9.4-24.6 9.4-33.9 0-9.3-9.4-9.4-24.6 0-33.9L303 71c9.4-9.4 24.6-9.4 33.9 0L441 175c9.4 9.4 9.4 24.6 0 33.9-9.4 9.3-24.6 9.4-33.9 0l-63-63V392zm-96-8h-88c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-88v-48h88c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64v-80c0-35.3 28.7-64 64-64h88v48zm168 56c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z" }, null, -1)
  ]))]))
}
export default { render: render }